import { FieldWrapper } from '@buildwise/libs/people';
import RenderFilterFieldByType from '@buildwise/libs/feed/components/RenderFilterFieldByType';
import { ConfigEntryType } from 'config/config';
import { useFormContext } from 'react-hook-form';
import { ModifyUserFormSchema } from '../../hooks/useUserForm';

type UserCustomFieldsProps = {
  fields: ConfigEntryType[];
};

function UserCustomFields({ fields }: UserCustomFieldsProps) {
  const {
    formState: { isSubmitting },
  } = useFormContext<ModifyUserFormSchema>();

  return (
    <>
      {fields.map((field) => (
        <FieldWrapper
          id={field.entryCode}
          label={field.referenceObject?.label || field.entryDescription}
          required={field.referenceObject?.isRequired}
          disabled={isSubmitting}
        >
          <RenderFilterFieldByType field={field} />
        </FieldWrapper>
      ))}
    </>
  );
}

export default UserCustomFields;
